// extracted by mini-css-extract-plugin
export default {"root":"IconMoreOptions_root__bQvaL"};